module.exports = __webpack_public_path__ + "img/services-icon.a82877ee.svg";